import { render, staticRenderFns } from "./copygoods.vue?vue&type=template&id=0c740d18&"
import script from "./copygoods.vue?vue&type=script&lang=js&"
export * from "./copygoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c740d18')) {
      api.createRecord('0c740d18', component.options)
    } else {
      api.reload('0c740d18', component.options)
    }
    module.hot.accept("./copygoods.vue?vue&type=template&id=0c740d18&", function () {
      api.rerender('0c740d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/copygoods.vue"
export default component.exports